import React, { Component } from 'react';
import { browserHistory } from 'react-router';

class ForgotPasswordConfirmation extends Component {
  onClickOk = () => {
    browserHistory.push('/');
  }

  render() {
    const { apiResponse } = this.props;
    return (
      <div
        className="modal fade theme-modal" id="forgotPasswordConfirmationModal"
        tabIndex="-1" aria-labelledby="forgotPasswordConfirmationModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p>{apiResponse}</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-12">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal" onClick={this.onClickOk}>OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPasswordConfirmation;
